import React from 'react';
// import content from "./assets/content.jpg";

import { FaGithub } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';
import { FaTwitter } from 'react-icons/fa';
import { useBlogContext } from '../Context/BlogContext';

const Main = () => {
  const { currentUser } = useBlogContext();
  // const style = {
  //   backgroundImage: `url(${content})`,
  //   backgroundSize: "contain",
  // };

  // bg-blue-100 mix-blend-overlay

  //   style={{ backgroundImage: `url(${content})` }}
  return (
    <div className='relative flex justify-center flex-col items-center h-40'>
      {/* <img src={content} alt="display" /> */}
      <h1 className='text-lg md:text-2xl z-10 font-bold'>
        Welcome {currentUser?.firstName}!
      </h1>
      <p className='text-black z-10 text-xs  md:text-base'>
        We Have The Right Content For Everyone, Explore Today.
      </p>
      <div className='flex gap-5 items-center mt-6'>
        <span className='z-10 animate-float transform md:p-3 p-2  hover:scale-110 bg-white ring-1 ring-gray-800 rounded-full      object-cover shadow-2xl transition duration-500 z-10'>
          <FaLinkedin color='#0077b5' />
        </span>{' '}
        <span className='z-10 transform  animate-refloat md:p-3 p-2   bg-white ring-1 ring-gray-400 rounded-full  object-cover shadow-2xl hover:scale-110 transition duration-500 z-10'>
          <FaGithub />
        </span>
        <span className='z-10 transform hover:scale-110 md:p-3 p-2  animate-float bg-white ring-1 ring-gray-800 rounded-full object-cover shadow-2xl transition duration-500 z-10'>
          <FaTwitter color='	#1DA1F2' />
        </span>
      </div>
      <div className='absolute top-0 left-0 bg-white  w-full h-full'></div>
    </div>
  );
};

export default Main;
